export const transformNavData = (linkGroups) => {
  if (!linkGroups) return null
  return linkGroups.map((group) => {
    if (group?.__typename === 'ContentfulNavigationLink') {
      return {
        text: group?.text,
        href: group?.href ?? '',
      }
    }

    const subnav =
      group?.links?.map((subItem) => ({
        text: subItem?.text,
        href: subItem?.href ?? '',
        subnav: subItem?.subnav?.map((subSubItem) => ({
          text: subSubItem?.text,
          href: subSubItem?.href ?? '',
        })),
      })) ?? []

    // Check if any subnav item has its own subnav. If so, mega menu styles will apply and links will get rendered
    const megaMenu = subnav.some(
      (subItem) => Array.isArray(subItem.subnav) && subItem.subnav.length > 0
    )

    return {
      text: group?.title,
      href: group?.href ?? '',
      megaMenu,
      subnav,
    }
  })
}

export const transformTopBarData = (topBarLinks) => {
  if (!topBarLinks) return []
  return topBarLinks.map((item) => ({
    text: item?.text,
    href: item?.href ?? '',
  }))
}
